// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"9d037050","453":"084f6dab"}[chunkId] + ".chunk.js";
};